
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import api from '@/api';
import Util from '@/utils/util';
import Swal from 'sweetalert2';

const { banner } = api;

@Component({})
export default class BannerList extends Vue {
  private data = { data: [], totalCount: 0, pageSize: 8, pageNo: 0 };

  private loading = false;

  private panel = 0;

  private headers = [
    { text: '名稱', value: 'name' },
    { text: '上架時間', value: 'startTime' },
    { text: '下架時間', value: 'endTime' },
    { text: '啟用狀態', value: 'status' },
    { text: '修改', value: 'edit' },
    { text: '刪除', value: 'delete' },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    q: this.$route.query.q ? this.$route.query.q : '',
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async handleEnableStatus(bannerId: any, IsEnabled: boolean) {
    const message = IsEnabled ? '停用' : '啟用';
    await Swal.fire(
      {
        title: `您確定要${message}嗎?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status } = IsEnabled ? await banner.disable(bannerId) : await banner.enable(bannerId);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: `${message}成功` });
          this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: `${message}失敗，請聯繫系統管理員。` });
        }
      }
    });
  }

  private async handleOpenDelete(bannerId: any) {
    await Swal.fire(
      {
        title: '您確定要刪除嗎?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status } = await banner.delete(bannerId);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '刪除成功' });
          this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: '刪除失敗，請聯繫系統管理員。' });
        }
      }
    });
  }

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async search() {
    this.filter.pageNo = 1;
    await this.query();
  }

  private async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      q: '',
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    this.loading = true;
    const { data } = await banner.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: BannerList) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
